const sharedMobileDesktop = require('../pages/content/career_EN.js');

export default {
  large: [
    {
      name: 'Career',
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                headerSize: 'large',
                header1: 'Join the fight.<br> It\'ll be fun<br>they said',
                text2: `<p>Fighting evil tech giants making money on brands and publishers (and building a new generation of e-commerce) takes talent.</p><p>We’re always on the look-out for new geniuses to join us. If you feel you’re the right person but can’t find your role in any the open positions here. Don’t hesitate, send us an email to <a href="mailto:career@spotin.com?subject=Career with Spotin, from website" style="text-decoration:underline">career@spotin.com</a> and tell us about yourself.</p>`,
              }
            },
            // bottom: {
            //   component: 'video-full',
            //   data: {
            //     blockModifiers: ['sideMargins'],
            //     src: 'desktop_spot.mp4',
            //     src: 'integration_lead.mp4',
            //   }
            // }
          }
        ]
      },
    },



    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        blockModifiers: ['noPaddingTop'],
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                columns: 2,
                component2: {
                  name: 'Career expandable list',
                  type: 'expandable-list',
                  data: {
                    icon: 'expand',
                    rotate45: true,
                    iconLeft: true,
                    active: null,
                    expandableGroups: sharedMobileDesktop.list
                  },
                }
              }
            },
          }
        ]
      },
    },

  ],
};



// WEBPACK FOOTER //
// ./pages/Career.js